module.exports = __webpack_public_path__ + "img/add.1ac22d5a.svg";